export default {
    created() {
        if (this.$options.pageLoaded) {
            this.$bus.on("pageLoaded", this.$options.pageLoaded.bind(this));
        }
    }
};
